import { Headphones, Globe2, Zap } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ConnectTrustRow() {
  const { t } = useTranslation("common");

  const items = [
    { icon: Headphones, label: t("trustHdQuality") },
    { icon: Globe2, label: t("trustWorldwide") },
    { icon: Zap, label: t("trustInstantCredit") },
  ];


  return (
    <section className="bg-muted/30 border-y">
      <div className="container mx-auto px-4 py-10">
        <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-sm">
          {items.map(({ icon: Icon, label }) => (
            <li
              key={label}
              className="inline-flex items-center gap-2 text-muted-foreground"
            >
              <Icon className="h-4 w-4 text-primary" aria-hidden="true" />
              <span className="font-medium text-foreground">{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
